<template>
  <van-tabbar v-model="newActive" active-color="var(--primary_color)" :border="false" @change="changeLang">
    <van-tabbar-item v-for="(item, index) in list" :key="index" :to="item.to">
      <div class="item">
        <svg-icon :class-name="newActive == item.to ? 'svgsActive' : 'svgs'" :icon-class="newActive == item.to ? item.icon+'_s' : item.icon" />
        <span :style="{ color: newActive === item.to ? 'var(--primary_color)' : 'var(--ntext_color)' }">{{ item.name
          }}</span>
      </div>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
import { mapGetters } from 'vuex'
import { EventBus } from '@/utils/event-bus'

export default {
  props: {
    active: {
      type: String,
      default: 'Home'
    }
  },
  computed: {
    ...mapGetters(['lang', 'basicConfig'])
  },
  watch: {
    lang() {
      this.changeLang()
    }
  },
  data() {
    return {
      newActive: '',
      list: []
    }
  },
  mounted() {
    this.changeLang()
    EventBus.$on('tabbar', () => {
      this.changeLang()
    })
  },
  activated() {
    this.changeLang()
  },
  methods: {
    changeLang() {
      this.newActive = this.active
      this.list = []
      this.list.push({
        name: this.$t('tabBar').home,
        icon: 'home',
        to: 'Home'
      })
      this.list.push({
        name: this.$t('tabBar').market,
        icon: 'market',
        to: 'Market'
      })
      this.list.push({
        name: this.$t('tabBar').trade,
        icon: 'trade',
        to: 'Trade'
      })
      if (!this.$store.state.isSim)
        this.list.push({
          name: this.$t('tabBar').heel,
          icon: 'heel',
          to: 'Finance'
        })
      else
        this.list.push({
          name: this.$t('tabBar').heel,
          icon: 'heel',
          to: 'FinanceSim'
        })
      this.list.push({
        name: this.$t('tabBar').asset,
        icon: 'asset',
        to: 'Asset'
      })
      this.list.push({
        name: this.$t('tabBar').my,
        icon: 'my',
        to: 'User'
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.van-tabbar {
  // border-top: 1px solid var(--info_color);
  background: var(--background_color);
  height: 50px;

  >>> .van-tabbar-item--active {
    background: none;
  }

  .item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .svgs {
      margin-bottom: 4px;
      width: 20px;
      height: 20px;
      color: var(--ntext_color);
    }

    .svgsActive {
      margin-bottom: 4px;
      width: 20px;
      height: 20px;
      color: var(--primary_color);
    }

    .Tsvgs {
      margin-bottom: 4px;
      width: 22px;
      height: 22px;
      color: var(--background_color);
    }

    .home {
      margin-top: -20px;
      margin-bottom: 6px;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: var(--text_color);
      display: flex;
      justify-content: center;
      align-items: center;
    }

    span {
      text-align: center;
      white-space: nowrap;
      font-size: 10px;
    }
  }
}
</style>
